/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntityTagHeaderValue } from './EntityTagHeaderValue';
import {
    EntityTagHeaderValueFromJSON,
    EntityTagHeaderValueFromJSONTyped,
    EntityTagHeaderValueToJSON,
    EntityTagHeaderValueToJSONTyped,
} from './EntityTagHeaderValue';

/**
 * 
 * @export
 * @interface FileResult
 */
export interface FileResult {
    /**
     * 
     * @type {string}
     * @memberof FileResult
     */
    contentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileResult
     */
    fileDownloadName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FileResult
     */
    lastModified?: Date | null;
    /**
     * 
     * @type {EntityTagHeaderValue}
     * @memberof FileResult
     */
    entityTag?: EntityTagHeaderValue | null;
    /**
     * 
     * @type {boolean}
     * @memberof FileResult
     */
    enableRangeProcessing?: boolean;
}

/**
 * Check if a given object implements the FileResult interface.
 */
export function instanceOfFileResult(value: object): value is FileResult {
    return true;
}

export function FileResultFromJSON(json: any): FileResult {
    return FileResultFromJSONTyped(json, false);
}

export function FileResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileResult {
    if (json == null) {
        return json;
    }
    return {
        
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'fileDownloadName': json['fileDownloadName'] == null ? undefined : json['fileDownloadName'],
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'entityTag': json['entityTag'] == null ? undefined : EntityTagHeaderValueFromJSON(json['entityTag']),
        'enableRangeProcessing': json['enableRangeProcessing'] == null ? undefined : json['enableRangeProcessing'],
    };
}

export function FileResultToJSON(json: any): FileResult {
    return FileResultToJSONTyped(json, false);
}

export function FileResultToJSONTyped(value?: FileResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contentType': value['contentType'],
        'fileDownloadName': value['fileDownloadName'],
        'lastModified': value['lastModified'] == null ? value['lastModified'] : value['lastModified'].toISOString(),
        'entityTag': EntityTagHeaderValueToJSON(value['entityTag']),
        'enableRangeProcessing': value['enableRangeProcessing'],
    };
}

